import { render, staticRenderFns } from "./return-list.vue?vue&type=template&id=e29c6d02&"
import script from "./return-list.vue?vue&type=script&lang=js&"
export * from "./return-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports